import { Injectable } from "@angular/core";


export interface CookieOptions {
  days?: number;
  path?: string;
  domain?: string;
  secure?: boolean;
  sameSite?: 'Strict' | 'Lax' | 'None';
}

@Injectable({
  providedIn: 'root'
})
export class CookieUtils {

  static setCookie(name: string, value: string, options: CookieOptions = {}): void {
    try {
      const {
        days = 365,
        path = '/',
        domain,
        secure = false,
        sameSite = 'Lax'
      } = options;

      const expires = new Date();
      expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));

      let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=${path}`;

      if (domain) {
        cookieString += `;domain=${domain}`;
      }

      if (secure) {
        cookieString += ';secure';
      }

      if (sameSite) {
        cookieString += `;samesite=${sameSite}`;
      }

      document.cookie = cookieString;
    } catch (error) {
      // Silent error handling
    }
  }

  static getCookie(name: string): string | null {
    try {
      const nameEQ = `${encodeURIComponent(name)}=`;
      const cookies = document.cookie.split(';');

      for (const cookie of cookies) {
        const trimmedCookie = cookie.trim();
        if (trimmedCookie.startsWith(nameEQ)) {
          return decodeURIComponent(trimmedCookie.substring(nameEQ.length));
        }
      }

      return null;
    } catch (error) {
      return null;
    }
  }

  static deleteCookie(name: string, path: string = '/', domain?: string): void {
    try {
      let cookieString = `${encodeURIComponent(name)}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=${path}`;

      if (domain) {
        cookieString += `;domain=${domain}`;
      }

      document.cookie = cookieString;
    } catch (error) {
    }
  }

  static hasCookie(name: string): boolean {
    return this.getCookie(name) !== null;
  }

  static getAllCookies(): Record<string, string> {
    try {
      const cookies: Record<string, string> = {};
      const cookieString = document.cookie;

      if (!cookieString) {
        return cookies;
      }

      const cookiePairs = cookieString.split(';');

      for (const pair of cookiePairs) {
        const [name, value] = pair.trim().split('=');
        if (name && value) {
          cookies[decodeURIComponent(name)] = decodeURIComponent(value);
        }
      }

      return cookies;
    } catch (error) {
      return {};
    }
  }

  static clearAllCookies(): void {
    try {
      const cookies = this.getAllCookies();
      for (const name of Object.keys(cookies)) {
        this.deleteCookie(name);
      }
    } catch (error) {
    }
  }
}
